<select #selectElement class="form-select" multiple="multiple">
  <ng-content></ng-content>
</select>
